import { FC } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { SingletonHooksContainer } from 'react-singleton-hook';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { SnackbarProvider } from 'notistack';

import store from '@store/store';
import Root from '@views/Root/Root';
import { theme } from '@utils/constants';

const App: FC = () => (
  <Provider store={store}>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <SnackbarProvider
            maxSnack={5}
            dense
            autoHideDuration={3000}
            preventDuplicate
            className="snackbar"
          >
            <SingletonHooksContainer />
            <Root />
          </SnackbarProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </BrowserRouter>
  </Provider>
);

export default App;
